import React from "react";
import { Stack, Typography, Card } from "investira.react.components";
import { formats, validators } from "investira.sdk";
import FundosAbertos from "./FundosAbertos";
import Observacoes from "./Observacoes";
import {
  SharpeCard,
  BetaCard,
  TreynorCard,
} from "../../../../components/molecules";
const Highlights = props => {
  const {
    data
  } = props;
  const {
    request,
    response
  } = data;
  return <>
      <Stack direction="column" sx={{
      gap: 2
    }} component="section" flexGrow={1}>
        <Stack gap={1} flexGrow={1}>
          <Stack gap={1}>
            <Card sx={{
            flex: 1,
            display: "flex"
          }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{
                fontWeight: 500
              }}>
                  Total Financeiro
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{
                    xs: "h6",
                    xl: "h5"
                  }} color="textPrimary">
                      <b>
                        {formats.formatNumber(response.resumo.financeiro || 0, 2, true, true)}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>

          <Stack gap={1} direction={{
          xs: "column",
          lg: "row"
        }} sx={{
          flex: 1,
          display: "flex"
        }}>
            <SharpeCard label="Sharpe" value={response.resumo.sharpe} //response.resumo.sharpe
          tooltip={<React.Fragment>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    <b>Sharpe</b>
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Mede o retorno excedente acima da taxa de juros livre de
                    risco.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" sx={{
              fontWeight: 500
            }}>
                    Valores de Referência:
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Mínimo: Geralmente, um Sharpe abaixo de 0 é indesejável,
                    pois indica que o investimento não compensa o risco em
                    relação a taxa de juros livre de risco.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" sx={{
              fontWeight: 500
            }}>
                    Ideal:
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">{`Sharpe > 1: Considerado bom, indicando retorno positivo ajustado ao risco.`}</Typography>
                  <Typography color="inherit" variant="caption" component="p">{`Sharpe > 2: Muito bom, refletindo eficiência significativa.`}</Typography>
                  <Typography color="inherit" variant="caption" component="p">{`Sharpe > 3: Excelente, comum em carteiras altamente otimizadas.`}</Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Máximo: Não há um limite teórico, mas valores acima de 3 são
                    raros e podem indicar dados inconsistentes ou períodos
                    específicos de mercado.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">
                    Um Sharpe maior implica melhor desempenho ajustado ao risco.
                    Comparar com benchmarks de mercado (ex.: Sharpe de um índice
                    como o S&P 500, que historicamente varia entre 0,5 e 1,5)
                    ajuda a contextualizar.
                  </Typography>
                </React.Fragment>} />
            <SharpeCard label="Sharpe EWMA" value={response.resumo.sharpe_ewma} tooltip={<React.Fragment>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    <b>Sharpe EWMA</b>
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Versão do Sharpe com volatilidade suavizada por média móvel
                    exponencialmente ponderada (EWMA), que dá mais peso as
                    oscilações mais recentes.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" sx={{
              fontWeight: 500
            }}>
                    Valores de Referência:
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">
                    Mínimo: Similar ao Sharpe tradicional, valores abaixo de 0
                    são indesejáveis.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">
                    {`Ideal: Mesmas faixas do Sharpe (>1 bom, >2 muito bom, >3 excelente).`}
                  </Typography>

                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Máximo: Sem limite teórico, mas valores muito altos requerem
                    validação, pois o EWMA pode subestimar volatilidade em
                    períodos de alta instabilidade.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">
                    Como o EWMA dá mais peso a dados recentes, pode ser mais
                    sensível a mudanças de mercado. Comparar com o Sharpe
                    tradicional para avaliar consistência.
                  </Typography>
                </React.Fragment>} />
          </Stack>

          <Stack gap={1} direction={{
          xs: "column",
          lg: "row"
        }} sx={{
          flex: 1,
          display: "flex"
        }}>
            <BetaCard label="Beta" value={response.resumo.beta} tooltip={<React.Fragment>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    <b>Beta</b>
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Mede a sensibilidade de um ativo ou carteira às
                    movimentações do mercado.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" sx={{
              fontWeight: 500
            }}>
                    Valores de Referência:
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Mínimo: Pode ser negativo (movimento inverso ao mercado,
                    comum em ativos defensivos ou hedges).
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" sx={{
              fontWeight: 500
            }}>
                    Ideal:
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">{`Beta ≈ 1: Movimento alinhado ao mercado (ex.: ETFs de índices amplos).`}</Typography>
                  <Typography color="inherit" variant="caption" component="p">{`Beta < 1: Menor volatilidade (ex.: ações defensivas, como utilities, com Beta entre 0,5 e 0,8).`}</Typography>
                  <Typography color="inherit" variant="caption" component="p">{`Beta > 1: Maior volatilidade (ex.: ações de tecnologia, com Beta entre 1,2 e 2,0).`}</Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Máximo: Não há limite, mas Betas acima de 2 são raros e
                    indicam alta sensibilidade ao mercado.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">
                    Um Beta de 1 é neutro. Valores menores indicam menor risco
                    sistemático; valores maiores, maior exposição ao mercado.
                  </Typography>
                </React.Fragment>} />
            <TreynorCard label="Treynor" value={response.resumo.treynor} benchmark={request.indicador_id} tooltip={<React.Fragment>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    <b>Treynor</b>
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Mede o retorno excedente por unidade de risco sistemático
                    (Beta).
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" sx={{
              fontWeight: 500
            }}>
                    Valores de Referência:
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    Mínimo: Valores negativos indicam que o investimento não
                    supera a taxa de juros livre de risco.
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p" sx={{
              fontWeight: 500
            }}>
                    Ideal:
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">{`Treynor > 0,05 (ou 5%): Considerado aceitável em mercados desenvolvidos.`}</Typography>
                  <Typography color="inherit" variant="caption" component="p">{`Treynor > 0,10 (ou 10%): Bom desempenho ajustado ao risco sistemático.`}</Typography>

                  <Typography color="inherit" variant="caption" component="p" gutterBottom>
                    {`Máximo: Não há limite teórico, mas valores muito altos (ex.: >0,20) são raros e podem refletir condições de mercado excepcionais.`}
                  </Typography>
                  <Typography color="inherit" variant="caption" component="p">
                    Comparar com o Treynor de índices de mercado (ex.: Ibovespa
                    ou S&P 500) para avaliar eficiência relativa. Mais útil para
                    carteiras diversificadas, onde o risco sistemático
                    predomina.
                  </Typography>
                </React.Fragment>} />
          </Stack>

          <Stack gap={1} direction={{
          xs: "column",
          md: "row"
        }} sx={{
          flex: 1,
          display: "flex"
        }}>
            <FundosAbertos data={data} />
            <Card sx={{
            flex: 1,
            display: "flex"
          }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{
                fontWeight: 500
              }}>
                  Ativos Analisados
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{
                    xs: "h6",
                    xl: "h5"
                  }} color="textPrimary">
                      <b>
                        {data.response?.resumo.estatisticas.quantidade_ativos_analisados}
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            {/* {!validators.isEmpty(data.request_metadata?.carteiras) && (
              <Consolidacao data={data} />
             )} */}
            {!validators.isEmpty(data.response?.resumo.erros) && <Observacoes data={data} />}
          </Stack>
        </Stack>
        <Stack gap={1}>
          <Stack gap={1} direction={{
          xs: "column",
          md: "row"
        }}>
            <Card variant="outlined" sx={{
            flex: 1,
            display: "flex",
            minHeight: 0
          }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{
                fontWeight: 500
              }}>
                  Amostragem
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{
                    xs: "h6",
                    xl: "h5"
                  }} color="textPrimary">
                      <b>{request.dias} dias</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
          <Stack gap={1} direction={{
          xs: "column",
          md: "row"
        }}>
            <Card variant="outlined" sx={{
            flex: 1,
            display: "flex",
            minHeight: 0
          }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{
                fontWeight: 500
              }}>
                  Confiança
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{
                    xs: "h6",
                    xl: "h5"
                  }} color="textPrimary">
                      <b>
                        {formats.formatNumber(request.confiancas, 0, true)}%
                      </b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            {request.indicador_id && <Card variant="outlined" sx={{
            flex: 1,
            display: "flex",
            minHeight: 0
          }}>
                <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                  <Typography variant="caption" color="textPrimary" sx={{
                fontWeight: 500
              }}>
                    Benchmark
                  </Typography>
                  <Stack direction="column" justifyContent="flex-end">
                    <Stack>
                      <Typography variant={{
                    xs: "h6",
                    xl: "h5"
                  }} color="textPrimary">
                        <b>{request.indicador_id}</b>
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Card>}
          </Stack>

          <Stack gap={1} direction={{
          xs: "column",
          md: "row"
        }}>
            <Card variant="outlined" sx={{
            flex: 1,
            display: "flex",
            minHeight: 0
          }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{
                fontWeight: 500
              }}>
                  Lambda EWMA
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{
                    xs: "h6",
                    xl: "h5"
                  }} color="textPrimary">
                      <b>{formats.formatNumber(request.peso_ewma, 0, true)}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card variant="outlined" sx={{
            flex: 1,
            display: "flex",
            minHeight: 0
          }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{
                fontWeight: 500
              }}>
                  Dias EWMA
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{
                    xs: "h6",
                    xl: "h5"
                  }} color="textPrimary">
                      <b>{request.dias_ewma}</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
            <Card variant="outlined" sx={{
            flex: 1,
            display: "flex",
            minHeight: 0
          }}>
              <Stack px={2} py={2} flexGrow={1} justifyContent="space-between">
                <Typography variant="caption" color="textPrimary" sx={{
                fontWeight: 500
              }}>
                  Juros Livre de Risco
                </Typography>
                <Stack direction="column" justifyContent="flex-end">
                  <Stack>
                    <Typography variant={{
                    xs: "h6",
                    xl: "h5"
                  }} color="textPrimary">
                      <b>{formats.formatNumber(request.juros, 3, true)} %</b>
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Card>
          </Stack>
        </Stack>
      </Stack>
    </>;
};
export default Highlights;
